var showOriginButton = function showOriginButton(images, index) {
  if (images && typeof index === 'number' && images[index] && images[index].originUrl) {
    return true;
  }

  return false;
};

export default showOriginButton;